import React from "react";

export function MarianneLogo({ size = 40, withText = true, onClick }) {
  return (
    <div
      className="flex items-center gap-3 cursor-pointer select-none"
      onClick={onClick}
      data-testid="marianne-logo"
    >
      <img
        src="/marianne-avatar.png"
        alt="Marianne"
        width={size}
        height={size}
        className="rounded-full border-2 border-marianne object-cover bg-white"
        style={{ width: size, height: size }}
      />
      {withText && (
        <div className="flex flex-col leading-none">
          <span className="font-head font-extrabold text-xl text-marianne tracking-tight">
            Marianne
          </span>
          <div className="tricolor-line h-[3px] w-full rounded-full mt-1" />
        </div>
      )}
    </div>
  );
}

export function MarianneHeader({ onLogoClick, right }) {
  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur border-b border-gray-100">
      <div className="tricolor-line h-[3px] w-full" />
      <div className="flex items-center justify-between px-5 py-3">
        <MarianneLogo size={40} onClick={onLogoClick} />
        {right}
      </div>
    </header>
  );
}
